import React from 'react';
import { Input } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field, antdErrorDisplayAdaptor } from 'src/components/RcForm';
import { sectionProps } from 'src/tools/constant';
import { get } from 'lodash';
const FieldInput = (props) => {
  const { disabled, title, name, maxLength, validator, breakpoint } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={title} size='small'>
        <Field
          name={name}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (validator) {
                  const res = validator(value, { breakpoint });

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, m) => {
            const eP = antdErrorDisplayAdaptor(m);
            return (
              <Input
                disabled={disabled}
                maxLength={maxLength}
                size='large'
                {...props}
                {...m}
                {...eP}
              />
            );
          }}
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default FieldInput;
